import { useNavigate } from '@tanstack/react-router'
import AnnualReportsCard from '../components/AnnualReportsCard'
import { usePermissions } from '@/utils/permissions'

export default function Reports() {
  const navigate = useNavigate()
  const permissions = usePermissions()

  // Redirect users without reports access
  if (!permissions.canAccessAnnualSummary()) {
    navigate({ to: '/' })
    return null
  }

  return (
    <div className="space-y-6">
      <AnnualReportsCard />
    </div>
  )
}
